"use client"
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { Link } from 'navigation';

const GoldLinkButton = ({
  textClassName = '',
  type = 'link',
  isNewTab = false,
  hasDownArrow = false,
  text,
  href,
  hasGoldBackground,
  hasGreenBackground,
  isCenteredHorizontally,
  className = '',
  isShowRightArrow = true,
  scrollToId = '' , 
  onClick = null,
  query = null,
}) => {
  const t = useTranslations('common')
const handleScrollToId = () =>{
const foundElemnt = document.getElementById(scrollToId).offsetTop - 80
if(foundElemnt){
  // globalSearch.scrollIntoView({ behavior: 'smooth' })
window.scrollTo({
  top: foundElemnt,
  behavior: 'smooth'
})
}
}
  const getArrowIcon = () => {
    if (hasGoldBackground && hasDownArrow) {
      return (
        <img
          src='https://storage.googleapis.com/rolzo-static-bucket/icons/primary_cta_icon_down.png'
          alt='arrow'
          width={10}
          height={10}
          className='h-auto w-[10px]'
        />
      )
    } else if (hasGoldBackground) {
      return (
        <img
          src='/images/primary_cta_icon.png'
          alt='arrow'
          width={10}
          height={10}
          className='h-[10px] w-auto'
        />
      )
    } else {
      return (
        <>
        <div className='size-[10px] w-[9.7px]  hidden group-hover:block'>
          <img
            src='/images/secondary_cta_icon_active.png'
            alt='arrow'
            width={10}
            height={10}
            className=' size-auto max-w-full max-h-full '
            />
            </div>
            <div className='h-[10px] w-[9.7px]  block group-hover:hidden'>
          <img
            src='https://storage.googleapis.com/rolzo-static-bucket/icons/secondary_cta_icon.png'
            alt='arrow'
            width={0}
            height={0}
            className='h-[10px] w-[6px]  max-w-full max-h-full'
          />
            </div>
        </>
      )
    }
  }

  return (
    type === 'link' && !scrollToId
    ?
    <Link
      href={{pathname : href || '/' , query : query}}
      target={isNewTab ? '_blank' : '_self'}
      className={`
        ${
          hasGoldBackground
            ? 'bg-rolzo-gold text-white rounded-full px-[14px] lg:px-5 hover:bg-black ' :
            hasGreenBackground ?
           'bg-[#0ebb2b] hover:bg-[#218838] text-white rounded-full px-[14px] lg:px-5'
           :
           ''
        }
        ${isCenteredHorizontally ? 'justify-center' : 'justify-start'}
        ${hasGoldBackground || hasGreenBackground ? 'hover:text-white' : 'hover:text-black'}
        py-[6px] lg:py-2
        text-rolzo-gold inline-flex items-center gap-2 text-[16px] group lg:text-[15px] font-light w-fit
        ${className} 
      `}
    >
      <p>{t(text)}</p>
      {isShowRightArrow &&
    getArrowIcon()
    }
    </Link>
    :
    !scrollToId && type === 'submitBtn'
    ?
    <button
    type='submit'
    className={`
      ${
        hasGoldBackground
          ? 'bg-rolzo-gold text-white rounded-full px-[14px] lg:px-5 hover:bg-black transition-colors duration-300 ease-in-out'
          : ''
      }
      ${isCenteredHorizontally ? 'justify-center' : 'justify-start'}
      ${hasGoldBackground ? 'hover:text-white' : 'hover:text-black'}
      py-1 lg:py-2
      text-rolzo-gold inline-flex items-center gap-2 text-[16px] group lg:text-[15px] font-light w-fit
      ${className}
    `}
  >
    <p className='w-full'>{t(text)}</p>
    {isShowRightArrow &&
    getArrowIcon()
    }
  </button>
  :
  <button
  type='button'
  className={`
    ${
      hasGoldBackground
        ? 'bg-rolzo-gold text-white rounded-full px-[14px] lg:px-5 hover:bg-black transition-colors duration-300 ease-in-out'
        : ''
    }
    ${isCenteredHorizontally ? 'justify-center' : 'justify-start'}
    ${hasGoldBackground ? 'hover:text-white' : 'hover:text-black'}
    py-1 lg:py-2
    text-rolzo-gold inline-flex items-center gap-2 text-[16px] group lg:text-[15px] font-light w-fit
    ${className}
  `}
  onClick={onClick ? onClick : handleScrollToId}
>
  <p className={`w-full ${textClassName}`}>{t(text)}</p>
  {isShowRightArrow &&
  getArrowIcon()
  }
</button>
  )
}

export default GoldLinkButton
